import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationItem, UserOrgItem } from 'src/app/models/dataModels';
import { APIService } from 'src/app/services/APIService';
import { AuctionService } from 'src/app/services/auction.service';
import { CommonService } from 'src/app/services/common.service';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
    selector: 'app-azienda-anagrafica',
    templateUrl: './azienda-anagrafica.component.html',
    styleUrls: ['./azienda-anagrafica.component.css'],
    standalone: false
})
export class AziendaAnagraficaComponent extends APIService {
  
  constructor(localUtil: LocalUtilService,
    public auctionService: AuctionService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    location: Location, 
    router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    translateService: TranslateService) {
    super(localUtil, location, router, translateService);
    this.loadOrganizationDetail();
  }

  orgDetail: OrganizationItem;
  userDetail: UserOrgItem;

  loadOrganizationDetail() {
    let authParams = this.localUtil.authParams;
    this.orgDetail = this.localUtil.authParams.organization_detail;
    this.userDetail = this.localUtil.authParams.user_detail;    
  }

}